import React, { useEffect, useState } from "react";
import { usePreload } from "../hooks/usePreload";
// import { LogType } from "../types";
import "./Logs.css";
import { Link, useNavigate } from "react-router-dom";
import Header from "./Header";

const Logs: React.FC = () => {
  const preload = usePreload();
  const logs = preload.logs;
  const users = preload.users;

  const queryParams = new URLSearchParams(location.search);
  const lla = queryParams.get("lla"); // LiveLet admin page = 1

  const navigate = useNavigate();

  const [activeActions, setActiveActions] = useState<string[]>(["view"]);
  // const [pageSize, setPageSize] = useState<number>(10);
  const [pageSize, setPageSize] = useState<number>(() => {
    const saved = localStorage.getItem('pageSize');
    return saved ? parseInt(saved, 10) : 10;
  });
  const pageSizes = [10, 25, 50, 100];
  const [currentPage, setCurrentPage] = useState<number>(1);

  const types: Record<string, string> = { "deleteCard": "カード削除", "view": "閲覧", "downloadCards": "ダウンロード", "scanCard": "スキャン", "saveImage-front": "カード前面保存", "saveImage-back": "カード背面保存", "login": "ログイン", "updateUser": "ユーザー編集", "deleteTag": "タグ削除", "saveCard": "カード保存" };

  useEffect(() => {
    localStorage.setItem('pageSize', pageSize.toString());
  }, [pageSize]);

  const pageSizesSelect = (<select value={pageSize} onChange={e => { setPageSize(parseInt(e.target.value)); setCurrentPage(1) }}
    className="rounded-full bg-primary-lightgray text-primary-darkgray py-2 px-2 border border-primary-bordergray">
    {pageSizes.map(size => <option key={size} value={size}>{size}</option>)}
  </select>);

  const uniqueActions = logs ? Array.from(new Set(logs.map(log => log.action))) : [];

  const filteredLogs = logs?.filter(log => activeActions.includes(log.action));

  const totalPages = Math.ceil((filteredLogs?.length || 1) / pageSize);
  const backOnePage = <span className="p-2 cursor-pointer border border-[#888] rounded-[0.5rem] shadow-sm bg-[rgba(255,255,255,0.5)] hover:bg-[rgba(255,255,255,1)] transition-colors duration-200" onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}>&lt;</span>;
  const currentPageDisplay = <span className="m-0 px-2">{currentPage} / {totalPages}</span>;
  const forwardOnePage = <span className="p-2 cursor-pointer border border-[#888] rounded-[0.5rem] shadow-sm bg-[rgba(255,255,255,0.5)] hover:bg-[rgba(255,255,255,1)] transition-colors duration-200" onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}>&gt;</span>;
  const pageControls = (<div className="flex gap-4 text-sm">{pageSizesSelect} <div className="px-2 mt-2">{backOnePage}{currentPageDisplay}{forwardOnePage}</div></div>);

  const actionToggles = (<div className="flex flex-wrap"> {uniqueActions.map(action => {
    const active = activeActions.includes(action);
    return (
      <div className={`action-toggle ${active ? "action-toggle-active" : "action-toggle-inactive"}`} key={action} onClick={() => {
        if (activeActions.includes(action)) {
          setActiveActions(activeActions.filter(activeAction => activeAction !== action));
        } else {
          setActiveActions([...activeActions, action]);
        }
        setCurrentPage(1);
      }}>{types[action]}</div>
    )
  })}</div>);

  const pagenatedLogs = filteredLogs?.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  // const logItems = (<div style={{ overflowY: "auto" }}>{pagenatedLogs?.map(log => {
  //   return (
  //     <div key={log.logKey} className="py-1">
  //       <span>{formatTimestamp(log.occuredAt)} - {LogToSentence(log)}</span>
  //     </div>
  //   )
  // })}</div>);

  // function LogToSentence(log: LogType): string | JSX.Element {
  //   const cards = preload?.cards;
  //   const actionUser = cards?.find(card => card.cardKey === log.userKey);
  //   const cardUser = cards?.find(card => card.cardKey === log.cardKey);
  //   const cardLink = (cardUser) ? (<Link to={`/camera/${cardUser.cardKey}`}>card #{cardUser.cardKey}</Link>) : "a card";

  //   switch (log.action) {
  //     case "deleteCard":
  //       return <span>{`User #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}) deleted card #${log.cardKey}.`}</span>;
  //     case "login":
  //       return <span>{`User #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}) logged in.`}</span>;
  //     case "downloadCards":
  //       return <span>{`User #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}) downloaded cards.`}</span>;
  //     case "saveCard":
  //       return <span>{`User #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}) saved `} {cardLink} {`(${cardUser?.content.firstName?.[0]?.content ?? ''} ${cardUser?.content.lastName?.[0]?.content ?? ''}).`}</span>;
  //     case "saveImage-front":
  //       return <span>{`User #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}) saved image for the front of `} {cardLink} {`(${cardUser?.content.firstName?.[0]?.content ?? ''} ${cardUser?.content.lastName?.[0]?.content ?? ''}).`}</span>;
  //     case "saveImage-back":
  //       return <span>{`User #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}) saved image for the back of `} {cardLink} {`(${cardUser?.content.firstName?.[0]?.content ?? ''} ${cardUser?.content.lastName?.[0]?.content ?? ''}).`}</span>;
  //     case "scanCard":
  //       return <span>{`User #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}) scanned a card.`}</span>;
  //     case "updateUser":
  //       return <span>{`User #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}) updated their profile.`}</span>;
  //     case "view":
  //       return <span>{`User #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}) viewed `} {cardLink} {`(${cardUser?.content.firstName?.[0]?.content ?? ''} ${cardUser?.content.lastName?.[0]?.content ?? ''}).`}</span>;
  //     default:
  //       return `Unknown action: ${log.action} by user #${log.userKey} (${actionUser?.content.firstName?.[0]?.content ?? ''} ${actionUser?.content.lastName?.[0]?.content ?? ''}).`;
  //   }
  // }

  const logContents = pagenatedLogs?.map(log => {
    const action = types[log.action] || "不明な操作";
    const cards = preload?.cards;
    const actionUserFromCards = cards?.find(card => card.cardKey === log.cardKey);
    const actionFirstNameFromCards = actionUserFromCards?.content.firstName?.find(name => name.language === "japanese")?.content || actionUserFromCards?.content.firstName?.[0]?.content;
    const actionLastNameFromCards = actionUserFromCards?.content.lastName?.find(name => name.language === "japanese")?.content || actionUserFromCards?.content.lastName?.[0]?.content;
    const actionNameFromCards = (actionFirstNameFromCards && actionLastNameFromCards) ? actionLastNameFromCards + ", " + actionFirstNameFromCards : null;
    const actionUserFromCompany = users?.find(user => user.userKey === log.userKey) || users?.find(user => user.externalUserKey === log.userKey);
    const actionFirstNameFromCompany = actionUserFromCompany?.firstName;
    const actionLastNameFromCompany = actionUserFromCompany?.lastName;
    const actionNameFromCompany = (actionFirstNameFromCompany && actionLastNameFromCompany) ? actionLastNameFromCompany + ", " + actionFirstNameFromCompany : null;
    const actionUserName = actionNameFromCards || actionNameFromCompany || '不明なユーザー';
    const cardUser = cards?.find(card => card.cardKey === log.cardKey);
    const cardLink = (cardUser) ? (<Link to={`/camera/${cardUser.cardKey}`}>詳細を表示</Link>) : "";
    const companyName = cardUser?.content.companyName?.[0].content ? cardUser?.content.companyName?.[1]?.content ? cardUser?.content.companyName?.[0].content : cardUser?.content.companyName?.[1]?.content : '';
    const cardName = (cardUser?.content.lastName?.[0]?.content ?? '') + (cardUser?.content.firstName?.[0]?.content ?? '');
    const title = cardUser?.content.title?.[0].content ? cardUser?.content.title?.[1]?.content ? cardUser?.content.title?.[0].content : cardUser?.content.title?.[1]?.content : '';

    return (
      <div key={log.logKey} className="grid grid-cols-7 py-2 border-b border-primary-bordergray min-w-[700px] text-sm">
        <div>{formatTimestamp(log.occuredAt)}</div>
        <div>{actionUserName}</div>
        <div>{action}</div>
        <div>{companyName}</div>
        <div>{cardName}</div>
        <div>{title}</div>
        <div className="">
          {cardLink}
        </div>
      </div>
    )
  });

  const llaTitle = <div className="my-8 top-title">閲覧履歴</div>
  const nativeTitle = (<div className="my-8 top-title">閲覧履歴</div>);

  return (
    <div className="top-page-container">
      {lla === "1" ? null : <Header />}
      {lla === "1" ? llaTitle : nativeTitle}
      {false && <p>Logs ({logs?.length}) will go here</p>}
      {false && <p>Unique Actions: {uniqueActions.join(", ")}</p>}
      <div className='flex flex-wrap log-border mb-6'>
        {actionToggles}
      </div>
      <div className="mb-6">
        {pageControls}
      </div>
      {/* <div className="bg-white drop-shadow-md p-5">
        {logItems}
      </div> */}

      <div className="bg-white drop-shadow-md mt-3 rounded-md overflow-x-auto">
        <div className="grid grid-cols-7 font-bold py-2 px-4 bg-primary-gray rounded-t-md min-w-[700px] text-sm">
          <div>日付</div>
          <div>操作ユーザー</div>
          <div>操作種類</div>
          <div>対象名刺会社名</div>
          <div>対象名刺氏名</div>
          <div>対象名刺役職</div>
          <div className="">名刺を表示</div>
        </div>
        <div className="px-2">
          {logContents}
        </div>

      </div>
    </div>
  );
}

export default Logs;

function formatTimestamp(occurredAt: string, timeZone: number = 9): string {
  // Parse the timestamp into a Date object
  const date = new Date(occurredAt);

  // Get the UTC time values
  const utcYear = date.getUTCFullYear();
  const utcMonth = date.getUTCMonth(); // 0-indexed
  const utcDate = date.getUTCDate();
  const utcHours = date.getUTCHours();
  const utcMinutes = date.getUTCMinutes();
  const utcSeconds = date.getUTCSeconds();

  // Adjust to the desired timezone
  const localHours = utcHours + timeZone;

  // Create a new Date object with adjusted hours
  const adjustedDate = new Date(Date.UTC(utcYear, utcMonth, utcDate, localHours, utcMinutes, utcSeconds));

  // Extract the adjusted values
  const year = adjustedDate.getUTCFullYear();
  const month = adjustedDate.getUTCMonth() + 1; // Convert to 1-indexed
  const day = adjustedDate.getUTCDate();
  const hours = adjustedDate.getUTCHours();
  const minutes = adjustedDate.getUTCMinutes();
  const seconds = adjustedDate.getUTCSeconds();

  // Format as "YYYY-MM-DD HH:MM:SS"
  const formattedDate = `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')} ` +
    `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

  return formattedDate;
}
